<template>
  <div class="stream-group-row d-flex justify-between items-center">
    <button
      class="move-detail-button-area d-flex justify-between items-center"
      @click="moveStreamGroupDetail(streamGroup.streamGroupId)"
    >
      <div class="stream-group-icon-wrapper">
        <img
          :src="require(`@/assets/images/${STREAM_GROUP_ICON}`)"
          alt="stream group icon"
          :class="['stream-group-icon', { 'is-active': isActiveStreamGroupIcon }]"
        />
        <span :class="['badge', { 'is-active-badge': isActiveStreamGroupIcon }]">{{
          streamGroup.contentCount
        }}</span>
      </div>
      <div class="stream-group-info">
        <div class="stream-group-title">
          {{ streamGroup.streamGroupName }}
        </div>
        <div class="stream-group-detail d-flex justify-between items-center">
          <div class="d-flex justify-between items-center">
            {{ convertSecToms(streamGroup.streamGroupDuration) }}
          </div>
        </div>

        <ja-stream-group-upload-status-badge :streamGroup="streamGroup" />
      </div>
    </button>
    <div class="steaming-switch-button-area">
      <button
        v-if="
          streamGroup.streamGroupUploadStatus === STREAM_GROUP_UPLOAD_STATUS.STREAM_GROUP_UPLOADING
        "
        :disabled="true"
        class="steaming-switch-button steaming-switch-button:disabled"
      >
        登録中
      </button>
      <button
        v-else
        @click="onClickStreamingSwtichButton(streamGroup.streamGroupId, isStreaming ? 0 : 1)"
        :disabled="isDisabledScheduleCancelButton"
        :class="[
          'steaming-switch-button',
          isStreaming ? 'streaming-button' : 'not-streaming-button',
        ]"
      >
        {{ isStreaming ? '停止' : '配信' }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import JaStreamGroupUploadStatusBadge from '@/components/JaStreamGroup/JaStreamGroupUploadStatusBadge.vue';
import { putStreamingStreamGroup } from '@/composable/data_push_common';
import { STREAM_GROUP_UPLOAD_STATUS, UPLOAD_STATUS_ID_LIST } from '@/composable/constant_common';
import { convertSecToms } from '@/composable/material_common';

// propsの受け取り
const props = defineProps({
  isStreaming: Boolean,
  streamGroup: Object,
  setIsAxiosWait: Function,
  getStreamGroup: Function,
  isAxiosWait: Boolean,
  openModal: Function,
  moveStreamGroupDetail: Function,
});

// 配信グループボタンアイコン画像名
const STREAM_GROUP_ICON = 'StreamGroupButton.png';

const isActiveStreamGroupIcon = computed(() => {
  const IS_ACTIVE_UPLOAD_STATUSES_ID = [
    UPLOAD_STATUS_ID_LIST.UPLOADED,
    UPLOAD_STATUS_ID_LIST.UPLOADING,
  ];
  return IS_ACTIVE_UPLOAD_STATUSES_ID.includes(props.streamGroup.uploadStatusId);
});

const isDisabledScheduleCancelButton = computed(() => {
  return props.isAxiosWait || props.streamGroup.uploadStatusId === UPLOAD_STATUS_ID_LIST.CANCEL;
});

/**
 * 配信ステータス更新処理
 */
const onClickStreamingSwtichButton = (streamGroupId, isStreaming) => {
  if (isStreaming) {
    props.openModal(streamGroupId);
  } else {
    // 通信処理中の場合は処理中止
    if (props.isAxiosWait) return;

    if (props.streamGroup.uploadStatusId === UPLOAD_STATUS_ID_LIST.CANCEL) {
      return;
    }
    const updateStreamingUploadStatusId = UPLOAD_STATUS_ID_LIST.CANCEL;
    // ボタン連打回避のためフラグ設定
    props.setIsAxiosWait(true);
    putStreamingStreamGroup(streamGroupId, updateStreamingUploadStatusId)
      .then(() => {
        // 配信ステータス更新成功時、親コンポーネントの配信グループ一覧取得を実行
        props.getStreamGroup();
      })
      .finally(() => {
        // ボタン連打回避のためフラグ設定
        props.setIsAxiosWait(false);
      });
  }
};
</script>

<style scoped>
/** 配信グループ */
.stream-group-row {
  box-sizing: border-box;
  border-bottom: 0.1rem solid #ddd;
  width: 100%;
  position: relative;
  padding-block: 1rem;
}
.stream-group-row:first-child {
  border-top: 0.1rem solid #ddd;
}

/** 詳細画面遷移ボタン */
.move-detail-button-area {
  background-color: white;
  border: none;
  width: 75%;
}

/** 配信状態アイコン */
.stream-group-icon-wrapper {
  height: 4rem;
  width: 4rem;
  padding: 2rem;
  position: relative;
}

.stream-group-icon {
  height: 100%;
  width: 100%;
  object-fit: contain;
  filter: gray;
  -webkit-filter: grayscale(1);
}

.is-active.stream-group-icon {
  /** アップロード完了している場合にはグレースケールフィルターを外す */
  filter: none;
}
/** コンテンツ数バッチアイコン */

.badge {
  background-color: rgba(170, 170, 170, 0.87);
  color: white;
  font-size: 1.1rem;
  padding: 0.3rem;
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 50%;
  position: absolute;
  right: 1.1rem;
  top: 1.5rem;
  z-index: 1;
}
.badge.is-active-badge {
  /** アップロード完了している場合にはグレースケールフィルターを外す */
  background-color: #21963b;
}

/** 配信グループ情報表示エリア */
.stream-group-info {
  flex-grow: 3;
}
.stream-group-title {
  font-size: 1.6rem;
  margin-bottom: 1rem;
  text-align: left;
  color: #222222;
}
.stream-group-detail {
  font-size: 1.4rem;
  color: #aaaaaa;
}

/** 配信状態切り替えボタン */
.steaming-switch-button-area {
  padding: 1.5rem;
}
.steaming-switch-button {
  font-size: 1.4rem;
  padding: 0.5rem 1rem;
  background-color: white;
  border: 1px #cccccc solid;
  border-radius: 0.5rem;
}
.steaming-switch-button:disabled {
  color: #9e9e9e;
}
.streaming-button {
  color: #e63030;
}
.not-streaming-button {
  color: #222222;
}
</style>
